const VARIANTS = {
  solid:
    "bg-brand-500 text-white shadow-sm hover:bg-brand-600 focus-visible:ring-brand-200",
  outline:
    "border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50 focus-visible:ring-gray-200",
};

// Full width pill button used across the unauthenticated screens.
const PrimaryButton = ({
  children,
  variant = "solid",
  className = "",
  ...props
}) => (
  <button
    className={`w-full rounded-full px-6 py-2.5 text-sm font-semibold transition focus:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-60 ${VARIANTS[variant]} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default PrimaryButton;
